__webpack_require__.p = "/reports-small-pie-chart-values/account-setup/";